import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "store/baseUrls";
import type { Result } from "store/api.type";
import type { Mode } from "./mode.model";
import type { Track } from "store/track/track.model";
import {Playlist} from "../playlist/playlist.model";

export const modeApi = createApi({
  reducerPath: "modeApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Accept", "application/json");
      headers.set("X-Api-Key", "4872bafc54269b2a7133705ab32c7e69");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getMode: builder.query<Mode, { modeId: string}>({
      query: ({modeId}) => `/v1/mode/${modeId}`,
      transformResponse: (data: Mode) => data,
    }),
    getModes: builder.query<Mode[], { isPersianMode?: boolean }>({
      query: ({isPersianMode = true}) => `/v1/mode?isPersianMode=${isPersianMode}`,
      transformResponse: (data: Result<Mode>) => data.list,
    }),
    getModeTracks: builder.query<
      Track[],
      { modeId: string; offset?: number; limit?: number }
    >({
      query: ({ modeId, offset = 0, limit = 20 }) =>
        `/v1/mode/${modeId}/tracks?offset=${offset}&maxSize=${limit}`,
      transformResponse: (data: Result<Track>) => data.list,
    }),
    getModePlaylists: builder.query<
        Playlist[],
        { modeId: string}
        >({
      query: ({ modeId}) =>
          `/v1/Mode/${modeId}/playlists`,
      transformResponse: (data: Result<Playlist>) => data.list,
    }),
  }),
});

export const {
  useGetModeQuery,
  useGetModesQuery,
  useGetModeTracksQuery,
  useGetModePlaylistsQuery,
  util: modeApiUtil,
} = modeApi;
